module.exports = __webpack_public_path__ + "img/415-768603.png";